// components/SimilarProfiles/SimilarProfiles.jsx
import React, { forwardRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import TagsList from "../More";
import { Link } from "react-router-dom";
import styles from "./SimilarProfiles.module.css";

const SimilarProfiles = forwardRef(({ profiles, role }, ref) => (
  <div className={styles.similarSlider}>
    <Swiper
      className={styles.similarSwiper}
      autoplay={{ delay: 5000 }}
      loop={true}
      ref={ref}
      observer={true}
      observeParents={true}
      modules={[Navigation, Autoplay]}
      spaceBetween={20}
      slidesPerView={3}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = ".similar-prev";
        swiper.params.navigation.nextEl = ".similar-next";
      }}
      breakpoints={{
        320: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 2 },
      }}
    >
      {profiles.map((profile, idx) => {
        const {photograph, fullName, profileSummary, country,
          currentDesignation,
          departmentFacultyName, 
          institutionName,
          user_id
        } = role === "mentor"  ? profile.mentor : profile.author;
        return (
        <SwiperSlide key={idx}>
          <div className={styles.card}>
            <div className={styles.headerOuter}>
              <div className={styles.left}>
                <div className={styles.imageWrapper}>
                  <img
                    src={photograph}
                    alt={fullName}
                    className={styles.profileImage}
                  />
                </div>
              </div>

              <div className={styles.right}>
                <div className={styles.header}>
                  <h3>{fullName}</h3>
                  {/* {profile.badge && (
                <span className={styles.badge}>{profile.badge}</span>
              )} */}
                </div>
                <p className={styles.title}>   {currentDesignation} | {departmentFacultyName} | {institutionName}</p>
              </div>
            </div>
            <div className={styles.ratingLocation}>
              {/* <div className={styles.ratingContainer}>
                <div className={styles.rating}>
                  <span>★</span>
                </div>
                <span className={styles.currency}>4.9</span>
              </div> */}
              <div className={styles.location}>{country}</div>
            </div>

            <div className={styles.description}>
              
            {profileSummary?.slice(0, 135) || ""}{" "}
              <Link to={`/${role}s/${user_id}`}>Read More</Link>
            </div>

            {/* <TagsList
              tags={profile.tags}
              tagsSize={4}
              showMore={true}
              profileId={profile.id}
            /> */}
          </div>
        </SwiperSlide>
      )
    }) 
    }
      {/* ✅ custom arrows */}
    </Swiper>
    <div className="similar-prev">&nbsp;</div>
    <div className="similar-next">&nbsp;</div>
  </div>
));
export default SimilarProfiles;
